module.exports = __webpack_public_path__ + "9d56249d09070f656a1c52e566448f0d.woff";